import uniqBy from 'lodash/uniqBy';
import type { LooseObject } from '~/types/generic';
import { ensureArrayValue } from '~/utils/blocks';

export default function buildFaqPageLdJsonFromSections(entry: LooseObject | null | undefined): LooseObject | null {
  const faqItems = collectFaqItems(entry);

  if (!faqItems.length) {
    return null;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };
}

function collectFaqItems(entry: LooseObject | null | undefined): Array<{ id?: string; question: string; answer: string }> {
  const sections = ensureArrayValue(entry?.sections);
  const items = sections.flatMap((section) =>
    ensureArrayValue(section?.faq_items).map((item) => ({
      id: item?.id,
      question: typeof item?.question === 'string' ? item.question.trim() : '',
      answer: typeof item?.answer === 'string' ? item.answer.trim() : '',
    }))
  );

  return uniqBy(
    items.filter((item) => item.question && item.answer),
    (item) => item.id || `${item.question}::${item.answer}`
  );
}
